import { render, staticRenderFns } from "./InsuranceParticular.vue?vue&type=template&id=0b93b891"
import script from "./InsuranceParticular.vue?vue&type=script&lang=js"
export * from "./InsuranceParticular.vue?vue&type=script&lang=js"
import style0 from "./InsuranceParticular.vue?vue&type=style&index=0&id=0b93b891&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports